import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'procure-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrl: './pdf-viewer.component.scss',
  imports: [NgxExtendedPdfViewerModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PdfViewer {
  readonly source = input.required<Blob>();
}
